<template>
  <v-container
    fluid
    class="pt-0"
  >
    <label class="title">Colunas do Layout</label>
    <v-data-table
      :class="{
        'elevation-1': columnsLength > 0,
        'elevation-0': columnsLength === 0,
      }"
      :headers="headersColumnsTable"
      :items="layoutColumns"
      :show-select="false"
      :height="columnsLength > 5 ? 580 : null"
      :items-per-page="-1"
      :loading="loadingLayoutColumnsTable"
      item-key="order"
      hide-default-footer
      fixed-header
      hide-default-header
      ref="LayoutColumnsTable"
    >
      <template v-slot:no-data>
        <span>Nenhuma coluna foi encontrada.</span>
      </template>
      <template v-slot:header="{ props }">
        <thead class="v-data-table-header">
          <tr class="table-header">
            <th
              class="backgroundHeaderColumn"
              v-for="header in props.headers"
              :key="header.text"
            >
              <v-col
                v-if="header.text === 'Ações'"
                align="center"
              >

                <v-tooltip
                  bottom
                >
                  <template v-slot:activator="{ on, attrs}">
                    <v-btn
                      color="primary"
                      small
                      v-bind="attrs"
                      v-on="on"
                      v-if="!propsIsVisualization && !inLayoutImportRoutesFlow"
                      @click="addColumn"
                    >
                      <v-icon color="foreground-accent">fas fa-plus</v-icon>
                    </v-btn>
                  </template>
                  <span>Adicionar Coluna</span>
                </v-tooltip>

                <v-menu
                  offset-y
                  bottom
                  left
                >
                  <template v-slot:activator="{ on: menu, attrs }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on: tooltip }">
                        <v-btn
                          color="primary"
                          small
                          v-bind="attrs"
                          v-on="{ ...menu, ...tooltip }"
                          v-if="!propsIsVisualization && inLayoutImportRoutesFlow"
                        >
                          <v-icon color="foreground-accent">fas fa-plus</v-icon>
                        </v-btn>
                      </template>
                      <span>Adicionar Coluna</span>
                    </v-tooltip>
                  </template>

                  <v-card width="315">
                    <v-container fluid>
                      <v-row justify="center">
                        <v-col cols="2" />

                        <v-col
                          cols="8"
                          class="d-flex justify-center align-center"
                        >
                          <span>Escolha o tipo da coluna</span>
                        </v-col>

                        <v-col
                          cols="2"
                          class="d-flex justify-center align-center"
                        >
                          <HintIcon :info="columnsInfo" />
                        </v-col>

                        <v-col
                          :cols="
                            ['RECEIVEMENT', 'SHIPPING'].includes(layoutData.typeIntegrationValue)
                              ? 6
                              : 12"
                          class="d-flex justify-center align-center"
                        >
                          <v-btn
                            width="130"
                            color="primary"
                            @click="addColumn()"
                          >
                            Convencional
                          </v-btn>
                        </v-col>

                        <v-col
                          cols="6"
                          class="d-flex justify-center align-center"
                          v-if="['RECEIVEMENT', 'SHIPPING'].includes(layoutData.typeIntegrationValue)"
                        >
                          <v-btn
                            v-if="layoutData.typeIntegrationValue === 'RECEIVEMENT'"
                            width="130"
                            color="primary"
                            @click="addComplementaryColumn()"
                          >
                            Complementar
                          </v-btn>

                          <v-btn
                            v-if="layoutData.typeIntegrationValue === 'SHIPPING'"
                            width="130"
                            color="primary"
                            @click="addVirtualColumn()"
                          >
                            Virtual
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>
                </v-menu>
              </v-col>
              <label
                v-else
                class="label primary--text"
              >
                {{ header.text }}
              </label>
            </th>
          </tr>
        </thead>
      </template>
      <template
        v-if="
          $vuetify.breakpoint.sm ||
          $vuetify.breakpoint.md ||
          $vuetify.breakpoint.lg ||
          $vuetify.breakpoint.xl
        "
        v-slot:body="props"
      >
        <draggable
          :list="props.items"
          tag="tbody"
          handle=".handle"
          @start="dragging = true"
          @end="dragging = false"
        >
          <tr
            v-for="(column, index) in props.items"
            :key="column.id"
          >
            <template>
              <td class="pr-0">
                <div class="d-flex flex-row">
                  <v-icon
                    :disabled="propsIsVisualization"
                    small
                    class="handle pr-4"
                    style="cursor: grab;"
                  >
                    fas fa-grip-vertical
                  </v-icon>

                  <HintIcon
                    v-if="setColumnInfo(column) !== false"
                    :info="setColumnInfo(column)"
                    :icon="setColumnIcon(column)"
                  />
                </div>
              </td>
            </template>
            <template>
              <td>
                <v-text-field
                  class="pt-4"
                  :value="(column.order = index + 1)"
                  solo
                  readonly
                  dense
                  :disabled="propsIsVisualization"
                  @input="debounceColumns()"
                />
              </td>
            </template>
            <template>
              <td>
                <v-text-field
                  v-model="column.name"
                  class="pt-4"
                  dense
                  solo
                  required
                  :rules="[rule.required]"
                  @input="noReferenceValidation(column, $event)"
                  :disabled="propsIsVisualization"
                  :readonly="propsIsVisualization"
                />
              </td>
            </template>
            <template>
              <td>
                <v-autocomplete
                  label="Tipo"
                  v-model="column.type"
                  :items="types"
                  class="pt-4"
                  dense
                  solo
                  :disabled="
                    propsIsVisualization || isVirtualColumn(column)
                  "
                  :rules="isVirtualColumn(column)
                    ? []
                    : [rule.required]
                  "
                  :readonly="propsIsVisualization"
                  @change="debounceColumns()"
                />
              </td>
            </template>
            <template>
              <td>
                <v-text-field
                  label="Tamanho"
                  solo
                  dense
                  v-mask="'####'"
                  type="number"
                  class="pt-4"
                  v-model="column.size"
                  @keydown="
                    $event.key === '-' ||
                    $event.key === '.' ||
                    $event.key === ','
                      ? $event.preventDefault()
                      : null
                  "
                  @input="onInputSize(column)"
                  @blur="
                    validateNumbersGreaterThanOne(column.size, 'fieldChecked')
                  "
                  id="fieldChecked"
                  :rules="onRulesSize(column)"
                  :disabled="
                    propsIsVisualization || isVirtualColumn(column)
                  "
                  :readonly="propsIsVisualization"
                />
              </td>
            </template>
            <template>
              <td>
                <v-row class="pb-2">
                  <v-col align="end">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          small
                          color="muted"
                          block
                          icon
                          v-bind="attrs"
                          v-on="on"
                          rounded
                          v-if="!propsIsVisualization"
                          @click="requestConfirmDeleteColumn(column)"
                        >
                          <v-icon color="error">fas fa-trash-alt</v-icon>
                        </v-btn>
                      </template>
                      <span>Excluir Coluna</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </td>
            </template>
          </tr>
        </draggable>
      </template>
      <template
        v-else-if="$vuetify.breakpoint.xs"
        v-slot:body="props"
      >
        <draggable
          :list="props.items"
          tag="tbody"
          handle=".handle"
        >
          <tr
            class="border"
            v-for="(column, index) in props.items"
            :key="column.id"
          >
            <template>
              <v-row class="mt-5">
                <v-col
                  cols="12"
                  align="center"
                >
                  <v-icon
                    small
                    class="handle"
                  >
                    fas fa-grip-vertical
                  </v-icon>
                </v-col>
              </v-row>
            </template>
            <template>
              <v-text-field
                class="pt-4"
                :value="(column.order = index + 1)"
                solo
                readonly
                dense
              />
            </template>
            <template>
              <v-text-field
                class="pt-4"
                dense
                v-model="column.name"
                solo
                required
                :rules="[rule.required]"
                @input="debounceColumns()"
              />
            </template>
            <template>
              <v-autocomplete
                v-model="column.type"
                :items="types"
                class="pt-4"
                dense
                solo
                @change="debounceColumns()"
              />
            </template>
            <template>
              <v-text-field
                label="Tamanho"
                solo
                dense
                v-mask="'####'"
                type="number"
                class="pt-4"
                v-model="column.size"
                @keydown="
                  $event.key === '-' || $event.key === '.' || $event.key === ','
                    ? $event.preventDefault()
                    : null
                "
                @input="onInputSize(column)"
                @blur="
                  validateNumbersGreaterThanOne(column.size, 'fieldChecked')
                "
                id="fieldChecked"
                :hide-details="false"
                :rules="
                  controlSizeInvalid
                    ? ['Número deve ser maior que 0']
                    : [rule.required]
                "
              />
            </template>
            <template>
              <v-row class="pb-2">
                <v-col align="end">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        small
                        color="muted"
                        block
                        icon
                        v-bind="attrs"
                        v-on="on"
                        rounded
                        @click="requestConfirmDeleteColumn(column)"
                      >
                        <v-icon color="error">fas fa-trash-alt</v-icon>
                      </v-btn>
                    </template>
                    <span>Excluir Coluna</span>
                  </v-tooltip>
                </v-col>
              </v-row>
              <v-divider />
            </template>
          </tr>
        </draggable>
      </template>
    </v-data-table>

    <SnackbarCustomize ref="SnackbarCustomize" />

    <ConfirmationModal
      ref="ConfirmationModal"
      @confirm="confirmAction"
      @cancel="cancelAction"
      :showCloseButton="false"
			:description="confirmModalDescription"
      color="primary"
      title="Atenção"
      cancelLabel="Cancelar"
      confirmLabel="Confirmar"
    />
  </v-container>
</template>

<script>
import draggable from 'vuedraggable';
import Formatters from '@/shared/formatters/formatters';
import Rules from '@/shared/validators/formRules';
import { observableMutationsRefreshToken } from '@/shared/observable/loadingRefreshToken';
import AuthService from '@/services-http/auth/AuthService';
import UserService from '@/services-http/security/UserService';
import UserUtils from '@/shared/utils/user-utils';
import SnackbarCustomize from '@/components/CustomAlerts/SnackbarCustomize.vue';
import { cloneDeep, debounce } from 'lodash';
import { mapGetters, mapMutations } from 'vuex';
import HintIcon from '@/components/HintIcon/HintIcon.vue';
import LayoutImportMixin from '@/shared/mixins/layoutImport/layoutImportMixin';
import ConfirmationModal from '@/components/Modals/ConfirmationModal/ConfirmationModal.vue';
import { hasEffectiveBearerToken } from '@/services/auth-strategy';
import GenericFunctionsMixin from '@/shared/mixins/genericFunctions/genericFunctionsMixin';
import { columnHTML } from './columnInfo';

export default {
  name: 'LayoutColumnComponent',

  components: { draggable, SnackbarCustomize, HintIcon, ConfirmationModal },

  data: () => ({
    controlSizeInvalid: false,
    headersColumnsTable: [
      {
        align: 'center',
        width: '1%',
        sortable: false,
      },
      {
        text: 'Campo',
        value: 'order',
        align: 'center',
        width: '10%',
        sortable: false,
      },
      {
        text: 'Nome',
        value: 'name',
        align: 'center',
        sortable: false,
      },
      {
        text: 'Tipo',
        value: 'type',
        align: 'center',
        width: '20%',
        sortable: false,
      },
      {
        text: 'Tamanho',
        value: 'size',
        align: 'center',
        width: '20%',
        sortable: false,
      },
      {
        text: 'Ações',
        value: 'actions',
        align: 'end',
        width: '8%',
        sortable: false,
      },
    ],
    types: [
      {
        value: 'ALPHANUMERIC',
        text: 'Alfanumérico',
      },
      {
        value: 'NUMERIC',
        text: 'Numérico',
      },
      {
        value: 'DATE',
        text: 'Data',
      },
    ],
    confirmModalDescription: '',
    actionType: '',
    columnToDelete: {},
    layout: {},
    columnPage: 1,
    loadingLayoutColumnsTable: true,
    SESSION_STORAGE_TOKEN: '@auth/token',
    SESSION_ODOO_TOKEN: '@auth-odoo/token',
    debounceColumns: null,
    dragging: false,
  }),

  props: {
    propsLayout: Object,
    propsIsVisualization: Boolean,
  },

  mixins: [
    LayoutImportMixin,
    GenericFunctionsMixin,
  ],

  watch: {
    propsLayout: {
      handler(val) {
        if (val) {
          this.layout = JSON.parse(JSON.stringify(val));
          this.loadingLayoutColumnsTable = false;
        }
      },
      deep: true,
      immediate: true,
    },
    layoutHeaderData: {
      deep: true,
      handler(newLayoutHeader, oldLayoutHeader) {
        if (this.areEqualDeep(newLayoutHeader, oldLayoutHeader)) return;

        this.layout = {
          ...newLayoutHeader,
          columns: this.layout.columns,
        }
      },
    },

    layoutColumnsData: {
      handler(newColumns, oldColumns) {
        if (this.areEqualDeep(newColumns, oldColumns)) return;

        this.layout.columns = newColumns;

        this.reorderingLayout();
      }
    },

    dragging: {
      handler(newValue, oldValue) {
        if (newValue === false && oldValue === true)
          this.updateColumns();
      },
    },
  },

  computed: {
    ...mapGetters({
      layoutData: 'layout-import/layout',
      layoutHeaderData: 'layout-import/layoutHeader',
      layoutColumnsData: 'layout-import/layoutColumns',
    }),
    layoutColumns() {
      if (
        this.layout &&
        this.layout.columns &&
        this.layout.columns.length > 0
      ) {
        const columns = [...this.layout.columns].sort((a, b) =>
          a.order > b.order ? 1 : -1
        );
        return columns;
      }
      return [];
    },
    columnsLength() {
      return this.layoutColumns.length;
    },
    columnsInfo() {
      return columnHTML;
    },
  },

  methods: {
    ...mapMutations({
      setLayoutColumns: 'layout-import/setLayoutColumns',
    }),
    confirmAction() {
      switch(this.actionType) {
        case 'deleteColumn':
          this.deleteColumn();

          break;
      };
    },
    cancelAction() {
      switch(this.actionType) {
        default:
          this.finishAction();

          break;
      };
    },
    async addColumn() {
      await this.checkToken();

      this.layout.columns.push({
        id: `new_column_${this.columnsLength + 1}`,
        name: '',
        order: this.columnsLength + 1,
        size: '',
        type: 'ALPHANUMERIC',
        transformations: [],
        validations: [],
        complementaryLayout: false,
        columnType: 'DEFAULT',
      });

      this.reorderingLayout();

      this.goToNewColumn();
    },
    async addComplementaryColumn() {
      await this.checkToken();

      this.layout.columns.push({
        id: `new_column_${this.columnsLength + 1}`,
        name: '',
        order: this.columnsLength + 1,
        size: '',
        type: 'ALPHANUMERIC',
        transformations: [],
        validations: [],
        complementaryLayout: true,
        columnType: 'DEFAULT',
      });

      this.reorderingLayout();

      this.goToNewColumn();
    },
    async addVirtualColumn() {
      await this.checkToken();

      this.layout.columns.push({
        id: `new_column_${this.columnsLength + 1}`,
        name: '',
        order: this.columnsLength + 1,
        function: '',
        complementaryLayout: false,
        columnType: 'VIRTUAL',
      });

      this.reorderingLayout();

      this.goToNewColumn();
    },
    goToNewColumn() {
      const layoutColumnsTable = this.$refs.LayoutColumnsTable.$el.firstChild;

      this.$nextTick(() => {
        layoutColumnsTable.scrollTo({
          top: layoutColumnsTable.scrollHeight,
          behavior: 'smooth'
        });
      });
    },
    requestConfirmDeleteColumn(column) {
      this.columnToDelete = column;

      this.actionType = 'deleteColumn';

      this.confirmModalDescription = `
        Tem certeza que deseja remover essa coluna?
      `;

      this.$refs.ConfirmationModal.open();
    },
    noReferenceValidation(item, str) {
      const normalize = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      const normalizedStr = normalize.toLowerCase();
      if (normalizedStr.includes('sem referencia')) {
        item.name = 'Sem Referência';
      }

      const currentRoute =
        this.$router && this.$router.currentRoute
          ? this.$router.currentRoute
          : false;

      if (currentRoute && currentRoute.path.includes('layout-model')) {
        this.$emit('updateLayout', this.layout);
      }

      this.debounceColumns();
    },
    onRulesSize(column) {
      if (this.isVirtualColumn(column))
        return [];

      if (this.controlSizeInvalid)
        return ['Número deve ser maior que 0'];

      return [this.rule.required];
    },
    async checkToken() {
      const tokenActive =
        sessionStorage.getItem(this.SESSION_STORAGE_TOKEN) ||
        sessionStorage.getItem(this.SESSION_ODOO_TOKEN) ||
        '';

      const shouldRefreshToken = hasEffectiveBearerToken(tokenActive)
        && this.rule.checkExpiredToken(tokenActive);
      if (shouldRefreshToken) {
        await this.refreshToken();
      }
    },
    async refreshToken() {
      const TOKEN_PREFIX = 'Bearer ';
      observableMutationsRefreshToken.setLoadingRefreshToken(true);
      try {
        const response = await this.authService.GetTokenFullByRefresh();
        if (response && response.data) {
          const { token } = response.data;
          const fullToken = `${TOKEN_PREFIX}${token}`;
          sessionStorage.setItem(this.SESSION_STORAGE_TOKEN, fullToken);
          sessionStorage.setItem(this.SESSION_ODOO_TOKEN, fullToken);
          await this.loadUserSessionData();
        }
      } catch (error) {
        console.error('Error refreshing tokens:', error);
      } finally {
        observableMutationsRefreshToken.setLoadingRefreshToken(false);
      }
    },
    onInputSize(column) {
      if (!column.size) return;

      column.size = this.formatter.removeInvalidNumber(column.size);

      this.debounceColumns();
    },
    async loadUserSessionData() {
      this.userService = new UserService();
      await this.userService
        .GetCurrent()
        .then((response) => {
          const session = response.data;
          if (session) {
            const userSessionStorage = {
              authorities: session.authorities,
              user: {
                id:
                  session.id
                    ? session.id
                    : null,
                name:
                  session.account && session.account.name
                    ? session.account.name
                    : null,
                email:
                  session.account && session.account.email
                    ? session.account.email
                    : null,
              },
            };
            this.userUtils.createUserSessionStorage(userSessionStorage);
          }
        })
        .catch((error) => {
          if (error && error.response && error.response.status === 401) {
            this.$refs.SnackbarCustomize.open('error', 'Token inexistente');
          }
        });
    },
    deleteColumn() {
      const index = this.layout.columns.findIndex(
        (element) => element.order === this.columnToDelete.order
      );
      this.layout.columns.splice(index, 1);

      this.reorderingLayout();

      setTimeout(() => {
        this.finishAction();
      }, 500)
    },
    finishAction() {
      this.actionType = '';
      this.columnToDelete = {};
    },
    validateNumbersGreaterThanOne(value, id) {
      if (parseFloat(value) < 1) {
        switch (id) {
          case 'fieldChecked':
            this.controlSizeInvalid = true;
            this.$emit('controlSizeInvalid', this.controlSizeInvalid);
            break;
          default:
            this.controlSizeInvalid = true;
            this.$emit('controlSizeInvalid', this.controlSizeInvalid);
            break;
        }
      } else {
        this.controlSizeInvalid = false;
        this.$emit('controlSizeInvalid', this.controlSizeInvalid);
      }
    },
    reorderingLayout() {
      this.$nextTick(() => {
        const columns = cloneDeep(this.layout.columns);
        this.layout.columns = this.sortColumns(columns);
      });

      this.updateColumns();

      this.$emit('updateLayout', this.layout);
    },
    updateColumns() {
      this.setLayoutColumns(this.layout.columns);
    },
  },

  created() {
    this.rule = new Rules();
    this.formatter = new Formatters();
    this.authService = new AuthService();
    this.userUtils = new UserUtils();
    this.debounceColumns = debounce(this.updateColumns, 200);
  },
};
</script>

<style scoped>
  .backgroundHeaderColumn {
    background-color: var(--v-muted-foreground-base) !important;
    text-align: center !important;
  }
</style>
